export default {
  //保存
  SAVE: '/jcnapi/solution/save',
  GET: '/jcnapi/solution/getInfo',
  GET_LIST: '/jcnapi/solution/getList',
  DEL: '/jcnapi/solution/delete',
  //企业简介 保存
  material: {
    SAVE: '/jcnapi/solution/material/save',
    GET_LIST: '/jcnapi/solution/material/getList',
    DEL: '/jcnapi/solution/material/delete'
  },
  //应用客户 保存
  customers: {
    SAVE: '/jcnapi/solution/customers/save',
    GET_LIST: '/jcnapi/solution/customers/getList',
    DEL: '/jcnapi/solution/customers/delete'
  }
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/solution/index.js